import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVve = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#VVE_svg__a)">
      <mask
        id="VVE_svg__b"
        width={18}
        height={22}
        x={2}
        y={9}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="m11 9.5-9 5.94V30.5h4v-8h5v8h9V15.44z"
        />
      </mask>
      <g mask="url(#VVE_svg__b)">
        <path
          fill="#F18700"
          d="M17.18 40.62 4.93 33.54 12 21.3z"
        />
        <path
          fill="#F7A941"
          d="m-7.32 26.47 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="M12 21.3 4.93 33.54l-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="M12 21.3-.25 14.22 6.82 1.98z"
        />
        <path
          fill="#F7A941"
          d="M6.82 1.98-.25 14.22l-12.24-7.07z"
        />
        <path
          fill="#F7A941"
          d="m-7.32 26.47 7.07-12.25L12 21.3z"
        />
        <path
          fill="#F18700"
          d="m12 21.3 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m17.18 40.62 7.07-12.25 12.24 7.07z"
        />
        <path
          fill="#F18700"
          d="m31.32 16.12-7.07 12.25L12 21.3zM6.82 1.98l12.25 7.07L12 21.3z"
        />
        <path
          fill="#F7A941"
          d="M31.32 16.12 19.07 9.05 26.14-3.2z"
        />
        <path
          fill="#F18700"
          d="m12 21.3 7.07-12.25 12.25 7.07z"
        />
      </g>
      <mask
        id="VVE_svg__c"
        width={18}
        height={22}
        x={20}
        y={9}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="m29 9.5-9 5.94V30.5h4v-8h5v8h9V15.44z"
        />
      </mask>
      <g mask="url(#VVE_svg__c)">
        <path
          fill="#FED27A"
          d="m33.29 24.53-12.24-7.08 7.07-12.24z"
        />
        <path
          fill="#FED27A"
          d="m8.8 10.38 12.25 7.07-7.08 12.25z"
        />
        <path
          fill="#FED27A"
          d="m13.97 29.7 7.08-12.25 12.24 7.08zM28.12 5.21l-7.07 12.24L8.8 10.38z"
        />
        <path
          fill="#F7A941"
          d="m13.97 29.7 12.25 7.07-7.07 12.25zM38.47 43.84l-12.25-7.07 7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="m33.29 24.53-7.07 12.24-12.25-7.07z"
        />
        <path
          fill="#FED27A"
          d="m8.8 10.38 7.07-12.24 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m28.12 5.21 12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#FED27A"
          d="m33.29 24.53 7.07-12.25 12.25 7.07zM47.43.03l-7.07 12.25-12.24-7.07zM33.29 24.53l12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#FED27A"
          d="M52.61 19.35 45.54 31.6l-12.25-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="VVE_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVve);

export default ForwardRef;
